
import { useAuth as useBetterAuthContext } from '@/context/AuthContext';

/**
 * Bridge hook that exposes Better Auth session details in the legacy shape
 */
export const useAuth = () => {
  const {
    sessionData,
    sessionIsPending,
    sessionError,
    sessionRefetch,
    sessionSignOut,
    getSessionToken,
  } = useBetterAuthContext();

  const sessionUser = sessionData?.user;

  const resolvedName = sessionUser
    ? sessionUser.fullName ||
      [sessionUser.firstName, sessionUser.lastName].filter(Boolean).join(' ') ||
      sessionUser.username ||
      sessionUser.id?.substring(0, 8) ||
      'Anonymous'
    : null;

  const normalizedUser = sessionUser
    ? {
        ...sessionUser,
        id: sessionUser.id || sessionUser.userId || sessionUser.internal_user_id,
        email:
          sessionUser.email ||
          sessionUser.emailAddresses?.[0]?.emailAddress ||
          null,
        name: resolvedName,
        role: sessionUser.role || sessionUser.publicMetadata?.role,
        clientId: sessionUser.clientId || sessionUser.publicMetadata?.clientId,
        defaultWorkspaceId:
          sessionUser.defaultWorkspaceId ||
          sessionUser.publicMetadata?.workspaceId,
      }
    : null;

  return {
    user: normalizedUser,
    sessionData,
    sessionRefetch,
    sessionSignOut,
    getSessionToken,
    isAuthenticated: !!sessionUser,
    isLoading: sessionIsPending,
    error: sessionError,
  };
};
